import React, { HTMLAttributes } from "react";
import { User, withUserAndChat } from "~/common/Store/connectUserAndChat";
import PlusFreeviewInitialAd from "./PlusFreeviewInitialAd";
import PlusFreeviewFinalAd from "./PlusFreeviewFinalAd";
import { FreeviewPromotionTypeStr } from "../../Store/models/User";
interface PlusFreeviewAdProps {
  user: User;
  containerProps?: HTMLAttributes<HTMLDivElement>;
  containerTestId?: string;
  gtmId?: string;
  freeviewInitialAdTestId?: string;
  freeviewFinalAdTestId?: string;
}
const PlusFreeviewAd = ({
  user,
  containerProps,
  containerTestId = "",
  gtmId = "",
  freeviewInitialAdTestId = "",
  freeviewFinalAdTestId = ""
}: PlusFreeviewAdProps) => {
  const showFreeview = user.freeviewPromotion && user.freeviewPromotion > 0;
  const showInitialAd = user.freeviewPromotion && (user.freeviewPromotion === FreeviewPromotionTypeStr.SporadicAd1 || user.freeviewPromotion === FreeviewPromotionTypeStr.HighVolumeAd1);
  return showFreeview ? <div {...containerProps} data-testid={containerTestId} gtm-id={gtmId} data-sentry-component="PlusFreeviewAd" data-sentry-source-file="index.tsx">
      {showInitialAd ? <PlusFreeviewInitialAd freeviewInitialAdTestId={freeviewInitialAdTestId} /> : <PlusFreeviewFinalAd freeviewFinalAdTestId={freeviewFinalAdTestId} />}
    </div> : null;
};
export default withUserAndChat(PlusFreeviewAd);